import {
    getEmailVerified,
    setEmailVerified,
    confirmEmailVerified,
    nextModalOpenVar,
    openModalOnce,
    callDatalayer,
    showUpsellFixedBanner,
} from "./module_common.js";

import { initSentry } from "./module_sentry.js";

import Cookies from 'js-cookie'

let checkModalOpen = true;

function enableLinksInCheckboxes() {
    $(document).on("tap click", 'label span a', function (event, data) {
        event.stopPropagation();
        event.preventDefault();
        window.open($(this).attr('href'), $(this).attr('target'));
        return false;
    });
}

// use this funcion before doLast()
export function disableModalOpenCheck(){
    checkModalOpen = false
}

const setRedirection = function(elem, url) {
    $(elem).click(function(){
        window.location.href = url;
    })
}

const parseOP = function(operations){
    operations.forEach(function(op){
        if (op["fn"] === "setRedir") {
            setRedirection(op["el"], op["url"]);
        }
    });
}

function isEmailAlredyVerified(notifyApiEmailVerified) {
    const data = getEmailVerified()
    if (!data) return false
    return data.uid === notifyApiEmailVerified.uid && data.code === notifyApiEmailVerified.code
}

// reload page after login+redirect, when user use browser back button
function reloadBrowserBack(){
    // call both on page load and after a browser back button
    window.addEventListener('pageshow', function (event) {
        const mrob = sessionStorage.getItem("mustReloadOnBack")
        if (!mrob) return

        // check if the page is load from a browser back button
        // the topic is not easy.. see https://github.com/GoogleChrome/web-vitals/issues/393
        const back = performance && 
        performance.getEntriesByType("navigation") &&
        performance.getEntriesByType("navigation")[0] && 
        performance.getEntriesByType("navigation")[0].type === 'back_forward'

        // event.persisted -> Indicates if the document is loading from a cache
        // performance.getEntriesByType("navigation") is a PerformanceEntry of type PerformanceNavigationTiming

        const comeFromBackButton = event.persisted || back
        if (comeFromBackButton && mrob == location.href) {
            sessionStorage.removeItem("mustReloadOnBack")
            location.reload()    
        }
    });
}

export function doLast(){
    initSentry()

    reloadBrowserBack()

    enableLinksInCheckboxes();

    if (UIDg){
        const dEvent = {
            'event':'intercomEvent',
            'email': UEM,
            'userId': UIDg,
            'name': Unm,
            'isPremium': UiP,
            'signupDate': UsgnD,
        }
        dataLayer.push(dEvent)
    }

    // ?? not used anymore?
    if (__OP.length > 0) {
        parseOP(__OP);
    }

    if (typeof notifyApiEmailVerified !== "undefined"){
        if (isEmailAlredyVerified(notifyApiEmailVerified)) return
        setEmailVerified(notifyApiEmailVerified)
        confirmEmailVerified(notifyApiEmailVerified);
    }

    if (checkModalOpen){
        // this operation clear nextModalOpenVar cookie
        const openMod = Cookies.get(nextModalOpenVar);
        if (openMod) {
            openModalOnce();
        }
    }

    callDatalayer();

    // not used anymore
    if (typeof showUpsellBanner !== "undefined") {
        showUpsellFixedBanner();
    }
}
